import { Box, Card, Grid, Skeleton } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../MachineDashboard/MachineDashboard.css";
import { images } from "../../../config";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import ArrowUpwardTwoToneIcon from "@mui/icons-material/ArrowUpwardTwoTone";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  getSmartTagGateway,
  getTagBarGraphData,
  getTagData,
  tagInteractionData,
  getIChartReportDetails,
  getTopBarTagDetails,
  getMRChartReportDetails,
  getSPCDashboardSideBarDetails,
} from "../services";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setSmartTagReportData } from "../MachineDashboard/Slice";
import SelectedTagGraphData from "../MachineDashboard/GraphmachineDashboard/selectedGraph";
import BarGraph from "../../../components/Graph/SmartTagBarGraph/BarGraph";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { userFootFallTracking } from "../../ProcessDashboard/service";
import { getPlantId } from "../../CompanyDashboard/services";
import SPCSelectedTagGraphData from "../MachineDashboard/GraphmachineDashboard/SPCSelectedTagGraphData";

const SmartTagSPCDashboard = () => {
  const [tagId, setTagId] = useState("");
  const [selectTimeRange, setSelectTimeRange] = useState("live");

  //graph state
  const [graphRealTimeData, setGraphRealTimeData] = useState([]);
  const [selectTagData, setSelectTagData] = useState([]);
  const [selectedDvTagname, setSelectedDvTagName] = useState("");
  const [selectedTagStatus, setSelectedTagStatus] = useState(0.0);

  // SPC Chart state (only for SPC mode)
  const [spcUclValue, setSpcUclValue] = useState(null);
  const [spcLclValue, setSpcLclValue] = useState(null);
  const [spcClValue, setSpcClValue] = useState(null);
  const [spcViolatedRule, setSpcViolatedRule] = useState("");
  const [spcGraphData, setSpcGraphData] = useState([]);

  // MR Chart state (only for SPC mode)
  const [mrUclValue, setMrUclValue] = useState(null);
  const [mrLclValue, setMrLclValue] = useState(null);
  const [mrClValue, setMrClValue] = useState(null);
  const [mrViolatedRule, setMrViolatedRule] = useState("");
  const [mrGraphData, setMrGraphData] = useState([]);
  const [topBarTagDetails, setTopBarTagDetails] = useState([]);
  const [isTopBarTagDetailsLoading, setIsTopBarTagDetailsLoading] =
    useState(true);

  // MR Chart API polling state
  const [mrPollingInterval, setMrPollingInterval] = useState(null);
  const mrPollingIntervalRef = useRef(null); // Store interval ID in ref to avoid cleanup issues
  const [mrStartDate, setMrStartDate] = useState(null);
  const [currentMRTagId, setCurrentMRTagId] = useState(null);
  const mrStartDateRef = useRef(null);
  const currentMRTagIdRef = useRef(null);
  const initialMRStartDateRef = useRef(null); // Store the initial start_date for all subsequent calls
  const [mrInterval, setMrInterval] = useState(5);
  const mrIntervalRef = useRef(5); // Ref to track current interval for polling

  // Store rule violations for each tag (tag_id -> rule text)
  const [IChartTagRuleViolations, setIChartTagRuleViolations] = useState({});

  // SPC API polling state
  const [spcPollingInterval, setSpcPollingInterval] = useState(null);
  const spcPollingIntervalRef = useRef(null); // Store interval ID in ref to avoid cleanup issues
  const [spcStartDate, setSpcStartDate] = useState(null);
  const [currentSPCTagId, setCurrentSPCTagId] = useState(null);
  const spcStartDateRef = useRef(null);
  const currentSPCTagIdRef = useRef(null);
  const initialStartDateRef = useRef(null); // Store the initial start_date for all subsequent calls
  const [spcInterval, setSpcInterval] = useState(5);
  const spcIntervalRef = useRef(5); // Ref to track current interval for polling
  const [selectedTagName, setSelectedTagName] = useState(""); // Store selected tag name from top bar

  // State to track selected card's real-time values
  const [selectedCardLatestValue, setSelectedCardLatestValue] = useState(null);
  const [selectedCardPercentageChange, setSelectedCardPercentageChange] =
    useState(null);

  // Top bar tag details polling state
  const topBarTagDetailsIntervalRef = useRef(null);

  // SPC Dashboard Sidebar Details polling state
  const spcSidebarDetailsIntervalRef = useRef(null);
  const currentSidebarTagIdRef = useRef(null);
  const sidebarStartDateRef = useRef(null);
  const [spcSidebarDetails, setSpcSidebarDetails] = useState({});

  const { overViewTagClickebleData } = useSelector(
    (state) => state.smartTagReportSlice
  );
  const [clickDataFromOverView, setClickDataFromOverView] = useState([]);

  useEffect(() => {
    setClickDataFromOverView(overViewTagClickebleData?.[0]);
  }, [overViewTagClickebleData]);
  const [plantId, setPlantId] = useState([]);
  // console.log("overViewTagClickebleData", overViewTagClickebleData);
  const { selectTimeZoneProfile } = useSelector((state) => state.userState);
  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 3,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const navigate = useNavigate();
  const params = useParams();

  const { tagClickebleData, smartTagtagMachineName } = useSelector(
    (state) => state.smartTagReportSlice
  );

  const tagIDData = tagClickebleData.length
    ? tagClickebleData.find((f) => f.plantId == params.plantid)?.["tagId"] ||
    false
    : false;

  const dispatch = useDispatch();

  useEffect(() => {
    if (tagId) {
      addInteractionData();
    }
  }, [tagId]);

  const addInteractionData = async () => {
    const param = {
      plant: params.plantid,
      tag: [tagId],
    };
    try {
      const resp = await tagInteractionData(param);
      if (resp.status == 200 || resp.status == 201) {
      }
    } catch (error) {
      // Error handling
    }
  };

  useEffect(() => {
    if (params.plantid) {
      handleGetPlantId();
    }
  }, [params.plantid]);

  const handleGetPlantId = async () => {
    const param = {
      company_id: params.companyid,
      plant_id: params.plantid,
    };
    try {
      const resp = await getPlantId(param);
      if (resp.status == 200 || resp.status == 201) {
        setPlantId(resp?.data?.payload || resp?.data);
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };


  const notifyError = (message) =>
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  const handleToastMsg = () => {
    notifyError("Please click on any tag");
  };

  // const getTagIdApi = async (tagId) => {
  //   const param = {
  //     tag: tagId,
  //   };
  //   try {
  //     const resp = await getTagData(param);
  //     if (resp.status == 200 || resp.status == 201) {
  //       setGraphRealTimeData([]);
  //       setSelectTagData(resp.data.payload);
  //       dispatch(
  //         setSmartTagReportData({
  //           deviceID: resp.data.payload.tag_config_data[0].device,
  //         })
  //       );
  //       dispatch(
  //         setSmartTagReportData({
  //           tagUNIT: resp.data.payload.tag_config_data[0].tag_unit,
  //         })
  //       );

  //       setSelectedDvTagName(
  //         resp.data.payload.tag_config_data &&
  //           resp.data.payload.tag_config_data[0] &&
  //           resp.data.payload.tag_config_data[0]?.device_tag !== null
  //           ? resp.data.payload.tag_config_data[0]?.device_tag
  //           : ""
  //       );
  //       dispatch(
  //         setSmartTagReportData({
  //           smartTagHIRange: resp.data.payload.tag_config_data[0].high_range,
  //         })
  //       );
  //       dispatch(
  //         setSmartTagReportData({
  //           smartTagLowRange: resp.data.payload.tag_config_data[0].low_range,
  //         })
  //       );
  //       dispatch(
  //         setSmartTagReportData({
  //           smartTagtagMachineName:
  //             resp.data.payload.tag_config_data[0]
  //               .device__machine__machine_name,
  //         })
  //       );

  //       setSelectedTagStatus(0.0);
  //     }
  //   } catch (error) {
  //     // Error handling
  //   }
  // };

  useEffect(() => {
    const findPlatTag = tagClickebleData.length
      ? tagClickebleData.find((f) => f.plantId == params.plantid)?.["tagId"] ||
      false
      : false;
    if (findPlatTag) {
      // getTagIdApi(findPlatTag);
    }
  }, [tagClickebleData]);

  useEffect(() => {
    setIsTopBarTagDetailsLoading(true);
  }, []);

  // Fetch top bar tag details API
  const getTopBarTagDetailsApi = async () => {
    const param = {
      plant: parseInt(params.plantid),
    };
    try {
      const resp = await getTopBarTagDetails(param);
      if (resp.status == 200 || resp.status == 201) {
        if (resp.data.payload && Array.isArray(resp.data.payload)) {
          setTopBarTagDetails(resp.data.payload);
        }
      }
    } catch (error) {
      console.log("Error fetching top bar tag details:", error);
    } finally {
      setIsTopBarTagDetailsLoading(false);
    }
  };

  // Fetch top bar tag details on mount and set up 5-minute polling
  useEffect(() => {
    // Call API immediately on mount
    getTopBarTagDetailsApi();

    // Set up 5-minute interval (5 * 60 * 1000 milliseconds)
    const intervalId = setInterval(() => {
      getTopBarTagDetailsApi();
    }, 5 * 60 * 1000);

    // Store interval ID in ref for cleanup
    topBarTagDetailsIntervalRef.current = intervalId;

    // Cleanup interval on unmount or when plantid changes
    return () => {
      if (topBarTagDetailsIntervalRef.current) {
        clearInterval(topBarTagDetailsIntervalRef.current);
        topBarTagDetailsIntervalRef.current = null;
      }
    };
  }, [params.plantid]);

  // Format date to "YYYY-MM-DD HH:MM:SS" format
  const formatDateTime = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  // Transform API response data to chart format
  const transformSPCData = (apiData) => {
    if (!apiData || !apiData.data) return [];

    return apiData.data
      .map((item) => {
        // Extract time from MIN_KEY or created_at
        const timeStr = item.MIN_KEY || item.created_at;
        if (!timeStr) return null;

        const date = new Date(timeStr);
        if (isNaN(date.getTime())) return null;

        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");
        const timeString = `${hours}:${minutes}:${seconds}`;

        // Check if there are rule breaks (violations)
        const isViolation = item.rule_break && item.rule_break.length > 0;

        // Handle null/undefined tag_value
        const tagValue =
          item.tag_value != null ? parseFloat(item.tag_value) : null;
        if (tagValue === null || isNaN(tagValue)) return null;

        return {
          tagValue: tagValue,
          tagTime: timeString,
          isViolation: isViolation,
          ruleBreak:
            item.rule_break && Array.isArray(item.rule_break)
              ? item.rule_break
              : [],
        };
      })
      .filter((item) => item !== null); // Filter out any null items
  };

  // Transform MR Chart API response data to chart format
  const transformMRData = (apiData) => {
    if (!apiData || !apiData.data) return [];

    return apiData.data
      .map((item) => {
        // Extract time from MIN_KEY or created_at
        const timeStr = item.MIN_KEY || item.created_at;
        if (!timeStr) return null;

        const date = new Date(timeStr);
        if (isNaN(date.getTime())) return null;

        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");
        const timeString = `${hours}:${minutes}:${seconds}`;

        // Check if there are rule breaks (violations)
        const isViolation = item.rule_break && item.rule_break.length > 0;

        // Handle MR value: API may return mr_value or tag_value (tag_value contains MR values in MR Chart response)
        // Try mr_value first, fallback to tag_value if mr_value is not present
        const mrValue =
          item.mr_value != null
            ? parseFloat(item.mr_value)
            : item.tag_value != null
              ? parseFloat(item.tag_value)
              : null;
        if (mrValue === null || isNaN(mrValue)) return null;

        return {
          tagValue: mrValue,
          tagTime: timeString,
          isViolation: isViolation,
          ruleBreak:
            item.rule_break && Array.isArray(item.rule_break)
              ? item.rule_break
              : [],
        };
      })
      .filter((item) => item !== null); // Filter out any null items
  };

  // Fetch SPC tag history data
  const fetchSPCTagHistoryData = async (tagId, startDate) => {
    const param = {
      company_id: parseInt(params.companyid),
      plant_id: parseInt(params.plantid),
      tag_id: parseInt(tagId),
      interval: spcIntervalRef.current, // Use ref to get latest interval value
      start_date: startDate,
    };

    try {
      const resp = await getIChartReportDetails(param);
      if (resp.status == 200 || resp.status == 201) {
        const payload = resp.data.payload;

        // Update control limit values from API response
        if (payload.cl_value !== undefined && payload.cl_value !== null) {
          setSpcClValue(Number(payload.cl_value));
        }
        if (payload.ucl_value !== undefined && payload.ucl_value !== null) {
          setSpcUclValue(Number(payload.ucl_value));
        }
        if (payload.lcl_value !== undefined && payload.lcl_value !== null) {
          setSpcLclValue(Number(payload.lcl_value));
        }

        console.log("SPC Control Limits from API:", {
          UCL: payload.ucl_value,
          CL: payload.cl_value,
          LCL: payload.lcl_value,
        });

        // Transform and update graph data
        const transformedData = transformSPCData(payload);
        console.log("Transformed SPC Data:", transformedData);
        console.log("Payload data:", payload.data);

        // Append new data to existing data (for continuous chart)
        setSpcGraphData((prevData) => {
          // Check if we should append or replace
          // If startDate is new, replace; if it's a continuation, append
          const lastDataTime =
            prevData.length > 0 ? prevData[prevData.length - 1].tagTime : null;

          if (transformedData.length > 0) {
            const firstNewTime = transformedData[0].tagTime;
            // If times overlap or are continuous, append; otherwise replace
            if (lastDataTime && firstNewTime >= lastDataTime) {
              // Append only new data points
              const existingTimes = new Set(prevData.map((d) => d.tagTime));
              const newData = transformedData.filter(
                (d) => !existingTimes.has(d.tagTime)
              );
              const result = [...prevData, ...newData];
              console.log("Appending data. New graph data:", result);
              return result;
            } else {
              // Replace with new data
              console.log("Replacing data. New graph data:", transformedData);
              return transformedData;
            }
          }
          console.log("No transformed data, keeping previous:", prevData);
          return prevData;
        });

        // Calculate and set violated rules based on latest non-empty rule entry
        let latestRuleText = "";
        if (payload.data && payload.data.length) {
          const latestRuleEntry = [...payload.data]
            .reverse()
            .find(
              (item) =>
                Array.isArray(item.rule_break) && item.rule_break.length > 0
            );
          if (latestRuleEntry) {
            latestRuleText = latestRuleEntry.rule_break.join(", ");
          }
        }
        setSpcViolatedRule(latestRuleText);

        // Store rule violation for this tag_id to display on the card
        setIChartTagRuleViolations((prev) => ({
          ...prev,
          [tagId]: latestRuleText,
        }));

        // Don't update start_date after API call - keep using the initial start_date
        // The initial start_date is set only when a new card is clicked
      }
    } catch (error) {
      console.log("Error fetching SPC tag history data:", error);
    }
  };

  // Fetch SPC Dashboard Sidebar Details
  const fetchSPCDashboardSideBarDetailsApi = async (tagId, startDate) => {
    const param = {
      company_id: parseInt(params.companyid),
      plant_id: parseInt(params.plantid),
      tag_id: parseInt(tagId),
      interval: spcIntervalRef.current, // Use I Chart interval as reference
      start_date: startDate,
    };

    try {
      const resp = await getSPCDashboardSideBarDetails(param);
      if (resp.status == 200 || resp.status == 201) {
        const payload = resp.data.payload;
        if (payload) {
          setSpcSidebarDetails(payload);
        }
      }
    } catch (error) {
      console.log("Error fetching SPC Dashboard Sidebar Details:", error);
    }
  };

  // Fetch MR Chart tag history data
  const fetchMRTagHistoryData = async (tagId, startDate) => {
    const param = {
      company_id: parseInt(params.companyid),
      plant_id: parseInt(params.plantid),
      tag_id: parseInt(tagId),
      interval: mrIntervalRef.current, // Use ref to get latest interval value
      start_date: startDate,
    };

    try {
      const resp = await getMRChartReportDetails(param);
      if (resp.status == 200 || resp.status == 201) {
        const payload = resp.data.payload;

        // Update control limit values from API response
        if (payload.cl_value !== undefined && payload.cl_value !== null) {
          setMrClValue(Number(payload.cl_value));
        }
        if (payload.ucl_value !== undefined && payload.ucl_value !== null) {
          setMrUclValue(Number(payload.ucl_value));
        }
        if (payload.lcl_value !== undefined && payload.lcl_value !== null) {
          setMrLclValue(Number(payload.lcl_value));
        }

        console.log("MR Chart Control Limits from API:", {
          UCL: payload.ucl_value,
          CL: payload.cl_value,
          LCL: payload.lcl_value,
        });

        // Transform and update graph data
        const transformedData = transformMRData(payload);
        console.log("Transformed MR Data:", transformedData);
        console.log("MR Payload data:", payload.data);

        // Append new data to existing data (for continuous chart)
        setMrGraphData((prevData) => {
          // Check if we should append or replace
          // If startDate is new, replace; if it's a continuation, append
          const lastDataTime =
            prevData.length > 0 ? prevData[prevData.length - 1].tagTime : null;

          if (transformedData.length > 0) {
            const firstNewTime = transformedData[0].tagTime;
            // If times overlap or are continuous, append; otherwise replace
            if (lastDataTime && firstNewTime >= lastDataTime) {
              // Append only new data points
              const existingTimes = new Set(prevData.map((d) => d.tagTime));
              const newData = transformedData.filter(
                (d) => !existingTimes.has(d.tagTime)
              );
              const result = [...prevData, ...newData];
              console.log("Appending MR data. New graph data:", result);
              return result;
            } else {
              // Replace with new data
              console.log(
                "Replacing MR data. New graph data:",
                transformedData
              );
              return transformedData;
            }
          }
          console.log("No transformed MR data, keeping previous:", prevData);
          return prevData;
        });

        // Calculate and set violated rules based on latest non-empty rule entry
        let latestRuleText = "";
        if (payload.data && payload.data.length) {
          const latestRuleEntry = [...payload.data]
            .reverse()
            .find(
              (item) =>
                Array.isArray(item.rule_break) && item.rule_break.length > 0
            );
          if (latestRuleEntry) {
            latestRuleText = latestRuleEntry.rule_break.join(", ");
          }
        }
        setMrViolatedRule(latestRuleText);

        // Don't update start_date after API call - keep using the initial start_date
        // The initial start_date is set only when a new card is clicked
      }
    } catch (error) {
      console.log("Error fetching MR Chart tag history data:", error);
    }
  };

  useEffect(() => {
    const tag_Id = overViewTagClickebleData[0]?.tag_id;
    const tagDetails = topBarTagDetails.find((item) => item.tag_id == tag_Id)

    if (tagDetails) {
      handleMachineCardClick(
        tagDetails.tag_id,
        tagDetails.tag_name,
        tagDetails.tag_comment,
        tagDetails.machine_id,
        tagDetails.tag_unit,
        tagDetails.device_name,
        tagDetails.device_id,
        tagDetails.latestValue,
        tagDetails.percentage_change,
      );
    } else {
      let OtherTagDetails = overViewTagClickebleData[0]
      handleMachineCardClick(
        OtherTagDetails.tag_id,
        OtherTagDetails.tagName,
        OtherTagDetails.tag_comment || OtherTagDetails.tagComment || OtherTagDetails.tagName,
        OtherTagDetails.machineId,
        OtherTagDetails.tagUnit,
        OtherTagDetails.deviceName,
        OtherTagDetails.deviceId,
        OtherTagDetails.latestValue,
        OtherTagDetails.percentageChange,
      );
      console.log("tagDetails_ELSE", OtherTagDetails);
    }
    console.log("tagDetails", tagDetails);
    console.log("overViewTagClickebleData", overViewTagClickebleData);

  }, [overViewTagClickebleData]);

  const handleMachineCardClick = async (
    tagId,
    tagName,
    tagComment,
    machineId,
    tagUnit,
    deviceName,
    deviceid,
    latestValue,
    percentageChange
  ) => {
    setSpcLclValue(null);
    setSpcUclValue(null);
    setSpcClValue(null);
    setMrUclValue(null);
    setMrLclValue(null);
    setMrClValue(null);
    setSpcViolatedRule("");
    setMrViolatedRule("");
    setIChartTagRuleViolations({});

    // Store the selected card's real-time values
    setSelectedCardLatestValue(latestValue);
    setSelectedCardPercentageChange(percentageChange);
    const existingIndex = tagClickebleData.findIndex(
      (item) => item.plantId === params.plantid
    );

    // if (existingIndex !== -1) {
    //   const updatedTagData = tagClickebleData.map((item, index) => {
    //     if (index === existingIndex) {
    //       return {
    //         ...item,
    //         machineId: machineId,
    //         tagUnit: tagUnit,
    //         tagId: tagId,
    //         tagName: tagName,
    //       };
    //     }
    //     return item;
    //   });

    //   dispatch(
    //     setSmartTagReportData({
    //       tagClickebleData: updatedTagData,
    //     })
    //   );
    // } else {
    //   dispatch(
    //     setSmartTagReportData({
    //       tagClickebleData: [
    //         ...tagClickebleData,
    //         {
    //           machineId: machineId,
    //           tagUnit: tagUnit,
    //           tagId: tagId,
    //           plantId: params.plantid,
    //           tagName: tagName,
    //         },
    //       ],
    //     })
    //   );
    // }

    // Clear existing polling intervals for both charts
    if (spcPollingIntervalRef.current) {
      clearInterval(spcPollingIntervalRef.current);
      spcPollingIntervalRef.current = null;
      setSpcPollingInterval(null);
    }
    if (mrPollingIntervalRef.current) {
      clearInterval(mrPollingIntervalRef.current);
      mrPollingIntervalRef.current = null;
      setMrPollingInterval(null);
    }

    setSelectedTagName(tagName);
    setSelectTagData({
      tag_config_data: [
        {
          tag_name: tagName,
          tag_comment: tagComment,
          device_name: deviceName,
          device_id: deviceid,
        },
      ],
    });

    // Reset I Chart data
    setSpcGraphData([]);
    setCurrentSPCTagId(tagId);
    currentSPCTagIdRef.current = tagId;

    // Reset MR Chart data
    setMrGraphData([]);
    setCurrentMRTagId(tagId);
    currentMRTagIdRef.current = tagId;

    // Set sidebar tag ID
    currentSidebarTagIdRef.current = tagId;

    // Set initial start_date to current time (this will be used for all subsequent calls)
    const currentDate = formatDateTime(new Date());

    // I Chart start date setup
    setSpcStartDate(currentDate);
    spcStartDateRef.current = currentDate;
    initialStartDateRef.current = currentDate; // Store the initial start_date

    // MR Chart start date setup
    setMrStartDate(currentDate);
    mrStartDateRef.current = currentDate;
    initialMRStartDateRef.current = currentDate; // Store the initial start_date

    // Sidebar start date setup
    sidebarStartDateRef.current = currentDate;

    // Fetch all data immediately with current date
    await Promise.all([
      fetchSPCTagHistoryData(tagId, currentDate),
      fetchMRTagHistoryData(tagId, currentDate),
      fetchSPCDashboardSideBarDetailsApi(tagId, currentDate),
    ]);

    // Set up polling interval for I Chart based on current interval value
    const setupSPCPollingInterval = () => {
      const intervalMinutes = spcIntervalRef.current;
      const intervalId = setInterval(async () => {
        // Use refs to get the latest values
        const tagIdToUse = currentSPCTagIdRef.current;
        // Always use the initial start_date for subsequent calls
        const dateToUse =
          initialStartDateRef.current || formatDateTime(new Date());
        if (tagIdToUse) {
          await fetchSPCTagHistoryData(tagIdToUse, dateToUse);
        }
      }, intervalMinutes * 60 * 1000); // Convert minutes to milliseconds

      spcPollingIntervalRef.current = intervalId;
      setSpcPollingInterval(intervalId);
    };

    // Set up polling interval for MR Chart based on current interval value
    const setupMRPollingInterval = () => {
      const intervalMinutes = mrIntervalRef.current;
      const intervalId = setInterval(async () => {
        // Use refs to get the latest values
        const tagIdToUse = currentMRTagIdRef.current;
        // Always use the initial start_date for subsequent calls
        const dateToUse =
          initialMRStartDateRef.current || formatDateTime(new Date());
        if (tagIdToUse) {
          await fetchMRTagHistoryData(tagIdToUse, dateToUse);
        }
      }, intervalMinutes * 60 * 1000); // Convert minutes to milliseconds

      mrPollingIntervalRef.current = intervalId;
      setMrPollingInterval(intervalId);
    };

    setupSPCPollingInterval();
    setupMRPollingInterval();

    // Set up polling interval for Sidebar Details (every 5 minutes)
    const setupSidebarPollingInterval = () => {
      const intervalId = setInterval(async () => {
        // Use refs to get the latest values
        const tagIdToUse = currentSidebarTagIdRef.current;
        // Always use the initial start_date for subsequent calls
        const dateToUse =
          sidebarStartDateRef.current || formatDateTime(new Date());
        if (tagIdToUse) {
          await fetchSPCDashboardSideBarDetailsApi(tagIdToUse, dateToUse);
        }
      }, 5 * 60 * 1000); // 5 minutes in milliseconds

      spcSidebarDetailsIntervalRef.current = intervalId;
    };

    setupSidebarPollingInterval();
  };

  useEffect(() => {
    const findPlatTag = tagClickebleData.length
      ? tagClickebleData.find((f) => f.plantId == params.plantid)?.["tagId"] ||
      false
      : false;
    if (findPlatTag) {
      // getTagIdApi(findPlatTag);
    }
  }, [tagClickebleData]);

  // useEffect(() => {
  //   const callUserFootFallTracking = () => {
  //     const moduleList = JSON.parse(localStorage.getItem("moduleList"));
  //     if (moduleList) {
  //       const module = moduleList.find(
  //         (m) => m.name === "SmarTag - Plant Process Dashboard"
  //       );
  //       if (module) {
  //         const param = {
  //           module_id: module.id,
  //           plant_id: parseInt(params.plantid), // assuming param.id is the plant_id
  //           company_id: parseInt(params.companyid), // assuming params.companyid is the company_id
  //         };
  //         try {
  //           userFootFallTracking(param);
  //         } catch (error) {
  //           console.error("Error calling userFootFallTracking:", error);
  //         }
  //       }
  //     }
  //   };

  //   // Call the function immediately on component mount
  //   callUserFootFallTracking();

  //   // Set up the interval to call the function every 15 minutes
  //   const intervalId = setInterval(callUserFootFallTracking, 5 * 60 * 1000); // 5 minutes in milliseconds

  //   // Clean up the interval when the component unmounts
  //   return () => clearInterval(intervalId);
  // }, [params.plantid, params.companyid]);
  // useEffect(() => {
  //   setGraphRealTimeData([]);
  // }, [selectTimeRange]);

  // Cleanup polling intervals on unmount only
  useEffect(() => {
    return () => {
      if (spcPollingIntervalRef.current) {
        clearInterval(spcPollingIntervalRef.current);
        spcPollingIntervalRef.current = null;
      }
      if (mrPollingIntervalRef.current) {
        clearInterval(mrPollingIntervalRef.current);
        mrPollingIntervalRef.current = null;
      }
      if (spcSidebarDetailsIntervalRef.current) {
        clearInterval(spcSidebarDetailsIntervalRef.current);
        spcSidebarDetailsIntervalRef.current = null;
      }
    };
  }, []); // Empty dependency array - only run on unmount

  // Update Real Time values when topBarTagDetails changes
  useEffect(() => {
    if (topBarTagDetails && topBarTagDetails.length > 0) {
      const currentTagId =
        currentSPCTagId || currentMRTagId || currentSidebarTagIdRef.current;
      if (currentTagId) {
        const selectedTag = topBarTagDetails.find(
          (tag) => tag.tag_id === currentTagId
        );
        if (selectedTag) {
          setSelectedCardLatestValue(selectedTag.latest_value);
          setSelectedCardPercentageChange(selectedTag.percentage_change);
        }
      }
    }
  }, [topBarTagDetails, currentSPCTagId, currentMRTagId]);

  const handleAnalyticsData = (type) => {
    // Find the currently selected tag from topBarTagDetails
    const currentTagId =
      currentSPCTagId || currentMRTagId || currentSidebarTagIdRef.current;

    if (!currentTagId) {
      toast.error("Please select a tag", {
        theme: "colored",
        position: toast.POSITION.TOP_RIGHT,
        toastClassName: "custom-toast",
      });
      return;
    }

    // Find the selected tag from topBarTagDetails
    const selectedTag = topBarTagDetails.find(
      (tag) => tag.tag_id === currentTagId
    );

    // if (!selectedTag) {
    //   toast.error("Selected tag data not found", {
    //     theme: "colored",
    //     position: toast.POSITION.TOP_RIGHT,
    //     toastClassName: "custom-toast",
    //   });
    //   return;
    // }

    // Extract required data from topBarTagDetails (selected card tag data)
    const topBarTagData = {
      device_name: selectedTag?.device_name || clickDataFromOverView?.deviceName || "",
      device_id: selectedTag?.device_id || clickDataFromOverView?.machineId || "",
      tag_id: selectedTag?.tag_id || clickDataFromOverView?.tag_id || "",
      tag_unit: selectedTag?.tag_unit || clickDataFromOverView?.tagUnit || "", // Selected card tag unit
      tag_comment: selectedTag?.tag_comment || clickDataFromOverView?.tagComment || "",
    };

    // Convert to SPCtagClickebleData format (similar to tagClickebleData structure)
    const spcTagClickebleData = [
      {
        machineId: selectedTag?.device_id || clickDataFromOverView?.machineId || "",
        tagUnit: selectedTag?.tag_unit || clickDataFromOverView?.tagUnit || "",
        tagId: selectedTag?.tag_id || clickDataFromOverView?.tag_id || "",
        plantId: params.plantid,
        tagName: selectedTag?.tag_comment || selectedTag?.tag_name || clickDataFromOverView?.tagComment || "",
      },
    ];

    // Store data in Redux with unique key
    dispatch(
      setSmartTagReportData({
        activeSPCClass: type,
        SPCTopBarTagData: topBarTagData,
        SPCtagClickebleData: spcTagClickebleData,
        SPCtagUnit: selectedTag?.tag_unit || "",
      })
    );

    // Navigate to appropriate page based on type

    navigate(
      `/Smarttag-spc-machineanalytics/company/${params.companyid}/plant/${params.plantid}/analytics`
    );
  };

  const handleIchartIntervalChange = (e) => {
    const newInterval = parseInt(e.target.value);
    setSpcInterval(newInterval);
    spcIntervalRef.current = newInterval; // Update ref immediately

    // Clear existing polling interval
    if (spcPollingIntervalRef.current) {
      clearInterval(spcPollingIntervalRef.current);
      spcPollingIntervalRef.current = null;
      setSpcPollingInterval(null);
    }

    // Call API immediately with new interval
    if (currentSPCTagId && initialStartDateRef.current) {
      fetchSPCTagHistoryData(currentSPCTagId, initialStartDateRef.current);
    }

    // Set up new polling interval with new duration
    if (currentSPCTagId) {
      const intervalMinutes = newInterval;
      const intervalId = setInterval(async () => {
        // Use refs to get the latest values
        const tagIdToUse = currentSPCTagIdRef.current;
        // Always use the initial start_date for subsequent calls
        const dateToUse =
          initialStartDateRef.current || formatDateTime(new Date());
        if (tagIdToUse) {
          await fetchSPCTagHistoryData(tagIdToUse, dateToUse);
        }
      }, intervalMinutes * 60 * 1000); // Convert minutes to milliseconds

      spcPollingIntervalRef.current = intervalId;
      setSpcPollingInterval(intervalId);
    }
  };

  const handleMRchartIntervalChange = (e) => {
    const newInterval = parseInt(e.target.value);
    setMrInterval(newInterval);
    mrIntervalRef.current = newInterval; // Update ref immediately

    // Clear existing polling interval
    if (mrPollingIntervalRef.current) {
      clearInterval(mrPollingIntervalRef.current);
      mrPollingIntervalRef.current = null;
      setMrPollingInterval(null);
    }

    // Call API immediately with new interval
    if (currentMRTagId && initialMRStartDateRef.current) {
      fetchMRTagHistoryData(currentMRTagId, initialMRStartDateRef.current);
    }

    // Set up new polling interval with new duration
    if (currentMRTagId) {
      const intervalMinutes = newInterval;
      const intervalId = setInterval(async () => {
        // Use refs to get the latest values
        const tagIdToUse = currentMRTagIdRef.current;
        // Always use the initial start_date for subsequent calls
        const dateToUse =
          initialMRStartDateRef.current || formatDateTime(new Date());
        if (tagIdToUse) {
          await fetchMRTagHistoryData(tagIdToUse, dateToUse);
        }
      }, intervalMinutes * 60 * 1000); // Convert minutes to milliseconds

      mrPollingIntervalRef.current = intervalId;
      setMrPollingInterval(intervalId);
    }
  };

  return (
    <>
      <div className="page-wraper">
        <Slider {...sliderSettings} className="my-slider-class">
          {isTopBarTagDetailsLoading
            ? // Skeleton loading cards
            Array.from({ length: 4 }).map((_, index) => (
              <Card
                key={`skeleton-${index}`}
                className="machinedashboard-tile d-flex justify-content-between flex-column"
              >
                <div className="d-flex justify-content-between">
                  <div>
                    <Skeleton
                      variant="text"
                      width={120}
                      height={20}
                      sx={{ mb: 1 }}
                    />
                  </div>
                  <div className="d-flex gap-1">
                    <Skeleton variant="circular" width={24} height={24} />
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-end">
                  <div>
                    <Skeleton
                      variant="text"
                      width={60}
                      height={40}
                      sx={{ mt: 2, mb: 1 }}
                    />
                    <Skeleton variant="text" width={100} height={16} />
                  </div>
                  <div className="d-flex gap-1 align-items-center">
                    <Skeleton
                      variant="rectangular"
                      width={24}
                      height={24}
                      sx={{ mr: 0.5 }}
                    />
                    <Skeleton variant="text" width={50} height={18} />
                  </div>
                </div>
              </Card>
            ))
            : // Actual data cards
            topBarTagDetails?.map((e, index) => {
              return (
                <Card
                  key={`card-${index}`}
                  className="machinedashboard-tile d-flex justify-content-between flex-column"
                  onClick={() =>
                    handleMachineCardClick(
                      e.tag_id,
                      e.tag_name,
                      e.tag_comment,
                      e.device_id,
                      e.tag_unit,
                      e.device_name,
                      e.device_id,
                      e.latest_value,
                      e.percentage_change
                    )
                  }
                >
                  <div className="d-flex justify-content-between">
                    <div>
                      <h6 style={{ fontSize: "15px" }}>
                        {e.tag_comment || e.tag_name}
                      </h6>
                    </div>
                    {/* Display rule violation on card if exists */}
                    {IChartTagRuleViolations[e.tag_id] && (
                      <p
                        style={{
                          fontSize: "12px",
                          color: "red",
                          margin: "2px 0 0 0",
                          fontWeight: "bold",
                        }}
                      >
                        {IChartTagRuleViolations[e.tag_id]}
                      </p>
                    )}
                    <div className="d-flex gap-1">
                      {/* {tag > hh ? (
                      <>
                        <div className="triangle-image-container">
                          <img
                            src={images.triandleFillIcon}
                            alt=""
                            className="triangle-image"
                          />
                          <span className="tooltip">HH alarm</span>
                        </div>
                        <div className="triangle-image-container">
                          <img
                            src={images.triandleFillIcon}
                            alt=""
                            className="triangle-image"
                          />
                          <span className="tooltip">HH alarm</span>
                        </div>
                      </>
                    ) : tag > hi ? (
                      <div className="triangle-image-container">
                        <img
                          src={images.triandleFillIcon}
                          alt=""
                          className="triangle-image"
                        />
                        <span className="tooltip">HI alarm</span>
                      </div>
                    ) : tag < ll ? (
                      <>
                        <div className="triangle-image-container">
                          <img
                            src={images.triangleDownIcon}
                            alt=""
                            className="triangle-image"
                          />
                          <span className="tooltip">LL alarm</span>
                        </div>
                        <div className="triangle-image-container">
                          <img
                            src={images.triangleDownIcon}
                            alt=""
                            className="triangle-image"
                          />
                          <span className="tooltip">LL alarm</span>
                        </div>
                      </>
                    ) : tag < lo ? (
                      <div className="triangle-image-container">
                        <img
                          src={images.triangleDownIcon}
                          alt=""
                          className="triangle-image"
                        />
                        <span className="tooltip">LO alarm</span>
                      </div>
                    ) : (
                      ""
                    )}*/}
                      {e.latest_value != null && e.is_sub ? (
                        <img
                          src={images.cloudActiveImg}
                          alt=""
                          className="triangle-image"
                        />
                      ) : (
                        <img
                          src={images.cloudImg}
                          alt=""
                          className="triangle-image"
                        />
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-end">
                    <div>
                      <h2 className="pt-3">
                        <b>{e.latest_value ? e.latest_value : ""}</b>
                        <span style={{ fontSize: "12px" }}>
                          {" "}
                          {e.tag_unit && e.latest_value ? e.tag_unit : " "}
                        </span>
                      </h2>
                      <h6 className="temperature-description">
                        {e.tag_name}
                      </h6>
                    </div>
                    <div className="d-flex gap-1">
                      {e.percentage_change ? (
                        <img
                          src={
                            e.percentage_change > 0
                              ? images.smartTagUpArrow
                              : images.smartTagDownArrow
                          }
                          alt="Arrow"
                          style={{ height: "36px" }}
                        />
                      ) : null}
                      <p className="mb-1">
                        <b>
                          {e.percentage_change
                            ? e.percentage_change + "%"
                            : "0.00 %"}
                        </b>
                      </p>
                    </div>
                  </div>
                </Card>
              );
            })}
        </Slider>

        <div className="pt-3">
          <div className="Temprature-box">
            <div className="p-3 position-relative">
              <div className="d-flex justify-content-between">
                <div className="d-flex">
                  <h6>
                    <b>
                      {selectTagData.tag_config_data &&
                        selectTagData.tag_config_data[0] &&
                        selectTagData.tag_config_data[0]?.tag_name !== null
                        ? selectTagData.tag_config_data[0]?.tag_name
                        : "-"}{" "}
                      :{" "}
                    </b>
                  </h6>
                  <h6 className="machine-temrature-title">
                    {selectTagData.tag_config_data &&
                      selectTagData.tag_config_data[0] &&
                      selectTagData.tag_config_data[0]?.tag_comment !== null
                      ? selectTagData.tag_config_data[0]?.tag_comment
                      : "-"}
                    {/* {selectTagData.tag_config_data &&
                    selectTagData.tag_config_data[0] &&
                    selectTagData.tag_config_data[0]?.tag_name !== null
                      ? selectTagData.tag_config_data[0]?.tag_name
                      : "-"}{" "} */}
                  </h6>
                </div>
                <div className="d-flex">
                  <button
                    className="smartTag-report-btn"
                    onClick={() => handleAnalyticsData("reports")}
                  >
                    Report
                  </button>
                  <button
                    className="smartTag-report-btn"
                    onClick={() => handleAnalyticsData("analytics")}
                  >
                    Analytics
                  </button>
                  <h5 className="mb-0 pt-1" style={{ marginLeft: "25px" }}>
                    <b>{smartTagtagMachineName}</b>
                  </h5>
                </div>
              </div>
              <div className="pt-2">
                <Grid container spacing={2} backgroundColor="white">
                  <Grid item xs={12} sm={12} md={5} lg={5}>
                    <Box className="Temrature-line-graph ">
                      <div
                        className="p-3"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p style={{ fontSize: "13px" }}>I Chart</p>
                        <div className="d-flex gap-2 align-items-center">
                          <p
                            style={{
                              margin: "0",
                              fontSize: "13px",
                              color: spcViolatedRule ? "red" : "black",
                            }}
                          >
                            {spcViolatedRule || ""}
                          </p>
                          <select
                            className="form-input-class"
                            style={{
                              padding: "6px 8px",
                              borderRadius: "4px",
                            }}
                            onChange={handleIchartIntervalChange}
                            value={spcInterval}
                          >
                            <option value="5">5 Min</option>
                            <option value="10">10 Min</option>
                            <option value="15">15 Min</option>
                          </select>
                        </div>
                      </div>
                      <div style={{ width: "100%" }}>
                        {(() => {
                          // Compute control limit values - prioritize API response values
                          const computedUclValue =
                            spcUclValue != null &&
                              spcUclValue !== undefined &&
                              !isNaN(spcUclValue)
                              ? Number(spcUclValue)
                              : selectTagData.tag_config_data?.[0]
                                ?.setpoint_hh != null &&
                                selectTagData.tag_config_data?.[0]
                                  ?.setpoint_hh !== undefined
                                ? Number(
                                  selectTagData.tag_config_data[0].setpoint_hh
                                )
                                : null;

                          const computedClValue =
                            spcClValue != null &&
                              spcClValue !== undefined &&
                              !isNaN(spcClValue)
                              ? Number(spcClValue)
                              : selectTagData.tag_config_data?.[0]
                                ?.setpoint_hi != null &&
                                selectTagData.tag_config_data?.[0]
                                  ?.setpoint_hi !== undefined
                                ? Number(
                                  selectTagData.tag_config_data[0].setpoint_hi
                                )
                                : null;

                          const computedLclValue =
                            spcLclValue != null &&
                              spcLclValue !== undefined &&
                              !isNaN(spcLclValue)
                              ? Number(spcLclValue)
                              : selectTagData.tag_config_data?.[0]
                                ?.setpoint_ll != null &&
                                selectTagData.tag_config_data?.[0]
                                  ?.setpoint_ll !== undefined
                                ? Number(
                                  selectTagData.tag_config_data[0].setpoint_ll
                                )
                                : null;

                          console.log("I Chart - Computed Control Limits:", {
                            UCL: computedUclValue,
                            CL: computedClValue,
                            LCL: computedLclValue,
                            spcUclValue,
                            spcClValue,
                            spcLclValue,
                          });

                          return (
                            <SPCSelectedTagGraphData
                              key={`ichart-${currentSPCTagId}-${computedUclValue}-${computedLclValue}-${computedClValue}`}
                              selectTagUnit={
                                selectTagData.tag_config_data?.[0]?.tag_name ||
                                ""
                              }
                              tag_hh={computedUclValue}
                              tag_hi={computedClValue}
                              tag_ll={computedLclValue}
                              graphRealTimeData={spcGraphData}
                            />
                          );
                        })()}
                      </div>
                    </Box>
                    <div className="pt-3 d-flex gap-3">
                      <Box className="RealTime-btn p-2">
                        <h6 className="box-real-time-title">Real Time</h6>
                        <h3 className="d-flex box-real-time-value align-items-center">
                          <b className="box-value">
                            {selectedCardLatestValue != null
                              ? parseFloat(selectedCardLatestValue).toFixed(2)
                              : "-"}
                          </b>
                          {(() => {
                            // Display percentage change from selected card
                            if (
                              selectedCardPercentageChange != null &&
                              selectedCardPercentageChange !== 0
                            ) {
                              const percentageChange = parseFloat(
                                selectedCardPercentageChange
                              );

                              if (!isNaN(percentageChange)) {
                                if (percentageChange > 0) {
                                  // Positive: up arrow with black color
                                  return (
                                    <>
                                      <ArrowUpwardTwoToneIcon
                                        style={{ color: "black" }}
                                      />
                                      <p
                                        style={{
                                          color: "black",
                                          fontSize: "18px",
                                          margin: "0",
                                        }}
                                      >
                                        {percentageChange.toFixed(2)}%
                                      </p>
                                    </>
                                  );
                                } else if (percentageChange < 0) {
                                  // Negative: down arrow with red color, text black
                                  return (
                                    <>
                                      <ArrowDownwardIcon
                                        style={{ color: "#E31E24" }}
                                      />
                                      <p
                                        style={{
                                          color: "black",
                                          fontSize: "18px",
                                          margin: "0",
                                        }}
                                      >
                                        {percentageChange.toFixed(2)}%
                                      </p>
                                    </>
                                  );
                                }
                              }
                            }
                            // If no percentage change or zero, show 0.00%
                            return (
                              <p
                                style={{
                                  color: "black",
                                  fontSize: "18px",
                                  margin: "0",
                                }}
                              >
                                0.00%
                              </p>
                            );
                          })()}
                        </h3>
                      </Box>
                      <Box className="RealTime-btn p-2">
                        <h6 className="box-real-time-title">UCL</h6>
                        <h3 className="box-real-time-value">
                          <b>
                            {spcUclValue != null && !isNaN(spcUclValue)
                              ? Number(spcUclValue).toFixed(2)
                              : "-"}
                          </b>
                        </h3>
                      </Box>
                      <Box className="RealTime-btn p-2">
                        <h6 className="box-real-time-title">LCL</h6>
                        <h3 className="box-real-time-value">
                          <b>
                            {spcLclValue != null && !isNaN(spcLclValue)
                              ? Number(spcLclValue).toFixed(2)
                              : "-"}
                          </b>
                        </h3>
                      </Box>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={5} lg={5}>
                    <Box className="Temrature-line-graph">
                      <div
                        className="p-3"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p style={{ fontSize: "13px" }}>MR Chart</p>
                        <div className="d-flex gap-2 align-items-center">
                          <p
                            style={{
                              margin: "0",
                              fontSize: "13px",
                              color: mrViolatedRule ? "red" : "black",
                            }}
                          >
                            {mrViolatedRule || ""}
                          </p>
                          <select
                            className="form-input-class"
                            style={{
                              padding: "6px 8px",
                              borderRadius: "4px",
                            }}
                            onChange={handleMRchartIntervalChange}
                            value={mrInterval}
                          >
                            <option value="5">5 Min</option>
                            <option value="10">10 Min</option>
                            <option value="15">15 Min</option>
                          </select>
                        </div>
                      </div>
                      <div style={{ width: "100%" }}>
                        {(() => {
                          // Compute control limit values - prioritize API response values
                          const computedMrUclValue =
                            mrUclValue != null &&
                              mrUclValue !== undefined &&
                              !isNaN(mrUclValue)
                              ? Number(mrUclValue)
                              : selectTagData.tag_config_data?.[0]
                                ?.setpoint_hh != null &&
                                selectTagData.tag_config_data?.[0]
                                  ?.setpoint_hh !== undefined
                                ? Number(
                                  selectTagData.tag_config_data[0].setpoint_hh
                                )
                                : null;

                          const computedMrClValue =
                            mrClValue != null &&
                              mrClValue !== undefined &&
                              !isNaN(mrClValue)
                              ? Number(mrClValue)
                              : selectTagData.tag_config_data?.[0]
                                ?.setpoint_hi != null &&
                                selectTagData.tag_config_data?.[0]
                                  ?.setpoint_hi !== undefined
                                ? Number(
                                  selectTagData.tag_config_data[0].setpoint_hi
                                )
                                : null;

                          const computedMrLclValue =
                            mrLclValue != null &&
                              mrLclValue !== undefined &&
                              !isNaN(mrLclValue)
                              ? Number(mrLclValue)
                              : selectTagData.tag_config_data?.[0]
                                ?.setpoint_ll != null &&
                                selectTagData.tag_config_data?.[0]
                                  ?.setpoint_ll !== undefined
                                ? Number(
                                  selectTagData.tag_config_data[0].setpoint_ll
                                )
                                : null;

                          console.log("MR Chart - Computed Control Limits:", {
                            UCL: computedMrUclValue,
                            CL: computedMrClValue,
                            LCL: computedMrLclValue,
                            mrUclValue,
                            mrClValue,
                            mrLclValue,
                          });

                          return (
                            <SPCSelectedTagGraphData
                              key={`mrchart-${currentMRTagId}-${computedMrUclValue}-${computedMrLclValue}-${computedMrClValue}`}
                              SPC={true}
                              selectTagUnit={
                                selectTagData.tag_config_data?.[0]?.tag_name ||
                                ""
                              }
                              tag_hh={computedMrUclValue}
                              tag_hi={computedMrClValue}
                              tag_ll={computedMrLclValue}
                              graphRealTimeData={mrGraphData}
                            />
                          );
                        })()}
                      </div>
                    </Box>
                    <div className="pt-3 d-flex gap-3">
                      <Box className="RealTime-btn p-2">
                        <h6 className="box-real-time-title">Real Time</h6>
                        <h3 className="d-flex box-real-time-value align-items-center">
                          <b className="box-value">
                            {mrGraphData.length &&
                              mrGraphData[mrGraphData.length - 1] &&
                              mrGraphData[mrGraphData.length - 1]["tagValue"] !=
                              null
                              ? parseFloat(
                                mrGraphData[mrGraphData.length - 1][
                                "tagValue"
                                ] || 0
                              ).toFixed(2)
                              : "-"}
                          </b>
                          {(() => {
                            // Calculate percentage change from last two data points
                            if (
                              mrGraphData.length >= 2 &&
                              mrGraphData[mrGraphData.length - 1] &&
                              mrGraphData[mrGraphData.length - 2] &&
                              mrGraphData[mrGraphData.length - 1]["tagValue"] !=
                              null &&
                              mrGraphData[mrGraphData.length - 2]["tagValue"] !=
                              null
                            ) {
                              const currentValue = parseFloat(
                                mrGraphData[mrGraphData.length - 1]["tagValue"]
                              );
                              const previousValue = parseFloat(
                                mrGraphData[mrGraphData.length - 2]["tagValue"]
                              );

                              if (
                                !isNaN(currentValue) &&
                                !isNaN(previousValue) &&
                                previousValue !== 0
                              ) {
                                const percentageChange =
                                  ((currentValue - previousValue) /
                                    previousValue) *
                                  100;
                                const roundedPercentage = Number(
                                  percentageChange.toFixed(2)
                                );

                                if (roundedPercentage > 0) {
                                  // Positive: up arrow with black color
                                  return (
                                    <>
                                      <ArrowUpwardTwoToneIcon
                                        style={{ color: "black" }}
                                      />
                                      <p
                                        style={{
                                          color: "black",
                                          fontSize: "18px",
                                          margin: "0",
                                        }}
                                      >
                                        +{roundedPercentage.toFixed(2)}%
                                      </p>
                                    </>
                                  );
                                } else if (roundedPercentage < 0) {
                                  // Negative: down arrow with red color, text black
                                  return (
                                    <>
                                      <ArrowDownwardIcon
                                        style={{ color: "#E31E24" }}
                                      />
                                      <p
                                        style={{
                                          color: "black",
                                          fontSize: "18px",
                                          margin: "0",
                                        }}
                                      >
                                        {roundedPercentage.toFixed(2)}%
                                      </p>
                                    </>
                                  );
                                } else {
                                  // Zero: no arrow, just text
                                  return (
                                    <p
                                      style={{
                                        color: "black",
                                        fontSize: "18px",
                                        margin: "0",
                                      }}
                                    >
                                      0.00%
                                    </p>
                                  );
                                }
                              }
                            }
                            // If not enough data or invalid values, show nothing or 0.00%
                            return (
                              <p
                                style={{
                                  color: "black",
                                  fontSize: "18px",
                                  margin: "0",
                                }}
                              >
                                0.00%
                              </p>
                            );
                          })()}
                        </h3>
                      </Box>
                      <Box className="RealTime-btn p-2">
                        <h6 className="box-real-time-title">UCL</h6>
                        <h3 className="box-real-time-value">
                          <b>
                            {mrUclValue != null && !isNaN(mrUclValue)
                              ? Number(mrUclValue).toFixed(2)
                              : "-"}
                          </b>
                        </h3>
                      </Box>
                      <Box className="RealTime-btn p-2">
                        <h6 className="box-real-time-title">LCL</h6>
                        <h3 className="box-real-time-value">
                          <b>
                            {mrLclValue != null && !isNaN(mrLclValue)
                              ? Number(mrLclValue).toFixed(2)
                              : "-"}
                          </b>
                        </h3>
                      </Box>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={2}
                    container
                    // justifyContent="center"
                    alignItems="space-between"
                    flexDirection="column"
                    justifyContent="space-between"
                    sx={{
                      padding: { xs: "10px", sm: "10px", md: "0px", lg: "0px" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: {
                          xs: "row",
                          sm: "row",
                          md: "column",
                          lg: "column",
                        },
                        flexWrap: {
                          xs: "wrap",
                          sm: "wrap",
                          md: "nowrap",
                          lg: "nowrap",
                        },
                        gap: { xs: "8px", sm: "10px", md: "8px", lg: "8px" },
                        width: "100%",
                        // justifyContent: {
                        //   xs: "center",
                        //   sm: "center",
                        //   md: "center",
                        //   lg: "center",
                        // },
                        // alignItems: "center",
                      }}
                    >
                      <Box
                        className="hh-box"
                        sx={{
                          width: {
                            xs: "calc(50% - 4px)",
                            sm: "calc(50% - 5px)",
                            md: "174px",
                            lg: "174px",
                          },
                          minWidth: {
                            xs: "140px",
                            sm: "150px",
                            md: "174px",
                            lg: "174px",
                          },
                          maxWidth: {
                            xs: "100%",
                            sm: "100%",
                            md: "174px",
                            lg: "174px",
                          },
                        }}
                      >
                        <h6 style={{ fontSize: "13px" }}>USL</h6>
                        <h5 style={{ float: "right" }}>
                          <b>
                            {spcSidebarDetails.usl_value
                              ? spcSidebarDetails.usl_value
                              : "-"}
                          </b>
                        </h5>
                      </Box>
                      <Box
                        className="hh-box"
                        sx={{
                          width: {
                            xs: "calc(50% - 4px)",
                            sm: "calc(50% - 5px)",
                            md: "174px",
                            lg: "174px",
                          },
                          minWidth: {
                            xs: "140px",
                            sm: "150px",
                            md: "174px",
                            lg: "174px",
                          },
                          maxWidth: {
                            xs: "100%",
                            sm: "100%",
                            md: "174px",
                            lg: "174px",
                          },
                        }}
                      >
                        <h6 style={{ fontSize: "13px" }}>LSL</h6>
                        <h5 style={{ float: "right" }}>
                          <b>
                            {spcSidebarDetails.lsl_value
                              ? spcSidebarDetails.lsl_value
                              : "-"}
                          </b>
                        </h5>
                      </Box>
                      <Box
                        className="hh-box"
                        sx={{
                          width: {
                            xs: "calc(50% - 4px)",
                            sm: "calc(50% - 5px)",
                            md: "174px",
                            lg: "174px",
                          },
                          minWidth: {
                            xs: "140px",
                            sm: "150px",
                            md: "174px",
                            lg: "174px",
                          },
                          maxWidth: {
                            xs: "100%",
                            sm: "100%",
                            md: "174px",
                            lg: "174px",
                          },
                        }}
                      >
                        <h6 style={{ fontSize: "13px" }}>CP</h6>
                        <h5 style={{ float: "right" }}>
                          <b>
                            {spcSidebarDetails.cp_value
                              ? spcSidebarDetails.cp_value
                              : "-"}
                          </b>
                        </h5>
                      </Box>
                      <Box
                        className="hh-box"
                        sx={{
                          width: {
                            xs: "calc(50% - 4px)",
                            sm: "calc(50% - 5px)",
                            md: "174px",
                            lg: "174px",
                          },
                          minWidth: {
                            xs: "140px",
                            sm: "150px",
                            md: "174px",
                            lg: "174px",
                          },
                          maxWidth: {
                            xs: "100%",
                            sm: "100%",
                            md: "174px",
                            lg: "174px",
                          },
                        }}
                      >
                        <h6 style={{ fontSize: "13px" }}>CPK</h6>
                        <h5 style={{ float: "right" }}>
                          <b>
                            {spcSidebarDetails.cpk_value
                              ? spcSidebarDetails.cpk_value
                              : "-"}
                          </b>
                        </h5>
                      </Box>
                    </Box>
                    {/* <Box
                      sx={{
                        width: {
                          xs: "100%",
                          sm: "100%",
                          md: "auto",
                          lg: "auto",
                        },
                        marginTop: {
                          xs: "10px",
                          sm: "10px",
                          md: "auto",
                          lg: "auto",
                        },
                        display: "flex",
                        justifyContent: {
                          xs: "center",
                          sm: "center",
                          md: "flex-end",
                          lg: "flex-end",
                        },
                      }}
                    >
                      <button
                        style={{
                          padding: "20px 73px",
                          float: "right",
                          borderRadius: "6px",
                          fontSize: "18px",
                          fontWeight: "500",
                          marginRight: "0px",
                        }}
                        className="smartTag-report-btn smartTag-analytics-sidebar-btn"
                        onClick={() => {
                          dispatch(
                            setSmartTagReportData({
                              activeSPCClass: "analytics",
                              SPCTopBarTagData: {},
                              SPCtagUnit: "",
                              SPCtagClickebleData: [],
                            })
                          );
                          navigate(
                            `/Smarttag-spc-machineanalytics/company/${params.companyid}/plant/${params.plantid}/analytics`
                          );
                        }}
                      >
                        Analytics
                      </button>
                    </Box> */}
                  </Grid>
                </Grid>
              </div>
              <Grid container spacing={1} className="pt-5 mb-3">
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <button
                    className="Process-dashboard-btn"
                    onClick={() => {
                      localStorage.setItem("is_SPC_Clicked", "true");
                      navigate(
                        `/smarttag-machineoverview/company/${params.companyid}/plant/${params.plantid}`
                      )
                    }}
                  >
                    OVERVIEW
                  </button>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <button
                    className="Process-dashboard-btn"
                    onClick={() => {
                      dispatch(
                        setSmartTagReportData({
                          activeSPCClass: "reports",
                          // SPCTopBarTagData: {},
                          // SPCtagUnit: "",
                          // SPCtagClickebleData: [],
                        })
                      );
                      navigate(
                        `/Smarttag-spc-machineanalytics/company/${params.companyid}/plant/${params.plantid}/analytics`
                      );
                    }}
                  >
                    REPORT
                  </button>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <button
                    className="Process-dashboard-btn"
                    onClick={() => {
                      dispatch(
                        setSmartTagReportData({
                          activeSPCClass: "analytics",
                          // SPCTopBarTagData: {},
                          // SPCtagUnit: "",
                          // SPCtagClickebleData: [],
                        })
                      );
                      navigate(
                        `/Smarttag-spc-machineanalytics/company/${params.companyid}/plant/${params.plantid}/analytics`
                      );
                    }}
                  >
                    ANALYTICS
                  </button>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>

                  <button
                    className="active-process-dashboard"
                    onClick={() => {
                      navigate(
                        `/Smarttag-machinedashboard/company/${params.companyid}/plant/${params.plantid}`
                      );
                    }}
                  >
                    SMART TAG DASHBOARD
                  </button>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SmartTagSPCDashboard;